<template>
  <div class="inner-box" @click="sendLogAndGoDetail(cellInfo)">
    <slot name="clickable-cell" />
  </div>
</template>
<script>
import CellMixIn from '@/mixins/cell.mixin'
import { sendEventLogSearchRecommendCell } from '@/common/utils/log.v2.send'
export default {
  name: 'CellLoggerWrapperSearchRecommend',
  mixins: [
    CellMixIn
  ],
  props: {
    index: {
      type: Number,
      default: null
    }
  },
  methods: {
    sendLogAndGoDetail (cellInfo) {
      sendEventLogSearchRecommendCell({ cellInfo: cellInfo, index: this.index })
      this.goDetail(cellInfo)
    }
  }
}
</script>
